const o=(o,r)=>o.hasErrorMessage?r.semanticColors.errorText:o.active?r.semanticColors.inputFocusBorderAlt:void 0;export{o as metaToLabelColor};
//# sourceMappingURL=FieldItem.types.js.map
